module.exports = __webpack_public_path__ + "static/media/GT_.0ba6031b.png";